<template>
  <div class="page-container">
    <span class="parent-path">帳號管理 / </span><span class="current-path">編輯帳號</span>
    <span class="page-title">編輯帳號</span>
    <div class="card-content">
      <form @submit.prevent="handleSubmit" class="company-form">

        <div class="section">
          <h2>基本資訊</h2>
          <div class="form-grid">
            <a-form-item :validateStatus="errors.last_name ? 'error' : ''" :help="errors.last_name">
              <a-label for="lastName">姓氏</a-label>
              <a-input v-model:value="user.last_name" id="lastName" type="text"/>
            </a-form-item>
            <a-form-item :validateStatus="errors.first_name ? 'error' : ''" :help="errors.first_name">
              <a-label for="firstName">名字</a-label>
              <a-input v-model:value="user.first_name" id="firstName" type="text"/>
            </a-form-item>
            <a-form-item class="form-group">
              <a-label for="email">電子信箱</a-label>
              <a-input v-model:value="user.email" id="email" type="text" readonly/>
            </a-form-item>
            <a-form-item class="form-group">
              <a-label for="company">公司</a-label>
              <a-input :value="company?.name" id="company" type="text" readonly/>
            </a-form-item>
            <a-form-item :validateStatus="errors.password ? 'error' : ''" :help="errors.password">
              <a-label for="password">密碼</a-label>
              <a-input v-model:value="user.password" id="password" type="password"/>
            </a-form-item>
            <a-form-item class="form-group">
              <a-label for="role">權限</a-label>
              <a-input :value="$t(`roles.${user.role}`)" id="role" type="text" readonly/>
            </a-form-item>
          </div>
        </div>

        <div class="form-actions">
          <a-button type="button" class="btn-cancel" @click="handleCancel">取消</a-button>
          <a-button html-type="submit" class="btn-submit">儲存</a-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {message} from "ant-design-vue";

export default {
  data() {
    return {
      user: {},
      company: {},
      errors: {
        first_name: "",
        last_name: "",
        password: "",
      }
    };
  },
  mounted() {

    const token = localStorage.getItem('token');
    this.$axios.get(`/api/users/${this.$route.params.id}`, {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }).then(response => {
      console.log(response.data.data)
      this.user = response.data.data
      this.company = this.user.organization
    }).catch(error => {
      console.error(error);
      if (error.status === 401) {
        this.$router.push('/login');
      }
    });
  },
  methods: {
    handleSubmit() {
      console.log("表單提交", this.form);

      for (let key in this.errors) {
        this.errors[key] = ""
      }

      const token = localStorage.getItem('token');
      this.$axios.patch(`/api/users/${this.$route.params.id}`, {
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        password: this.user.password,
        email: this.user.email
      }, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      }).then(response => {
        console.log(response)
        message.success('已完成帳號編輯');
      }).catch(error => {
        console.error(error);
        if (error.status === 401) {
          this.$router.push('/login');
        } else {
          console.log(error.response.data);
          let errors = error.response.data
          for (let key in errors) {
            this.errors[key] = errors[key]['message']
          }
        }
      });
    },
    handleCancel() {
      this.$router.go(-1)
    },
  },
};
</script>

<style scoped>
.card-content {
  background-color: white;
  border-radius: 8px;
  width: 1024px;
  padding: 20px;
  margin-top: 16px;
}

h1 {
  font-size: 1.5em;
  margin-bottom: 1em;
}

.section {
  margin-bottom: 2em;
}

.section h2 {
  font-size: 1.2em;
  margin-bottom: 1em;
}

.form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1em;
}

.form-group {
  display: flex;
  flex-direction: column;
}

label {
  font-size: 0.9em;
  margin-bottom: 0.5em;
  color: #333;
}

input {
  padding: 0.7em;
  font-size: 1em;
  border: 1px solid #ccc;
  border-radius: 4px;
}

input:focus {
  outline: none;
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(0, 123, 255, 0.5);
}

input[readonly] {
  background-color: #e0e0e0;
  border: solid 1px #999999;
}

.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 1em;
}

.btn-cancel {
  background-color: #f8f9fa;
  color: #333;
}

.btn-submit {
  background-color: #007bff;
  color: white;
}

.btn-submit:hover {
  background-color: #0056b3;
}
</style>
